import styled, { css } from 'styled-components';

export const StyledSpan = styled.span`
  ${({ clickable }) =>
    clickable &&
    css`
      cursor: pointer;
    `}
`;
